import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
//import "./BenefitsSetup.css";

const BenefitsDental = () => {
    const { id } = useParams();

    const [carriers, setCarriers] = useState([]);
    const [plans, setPlans] = useState([
        {
            type: "",
            planName: "",
            carrierId: "",
            employeeShare: "",
            employerShare: 0,

            // Tier costs
            costEmployeeOnly: "",
            costEmployeeSpouse: "",
            costEmployeeChildren: "",
            costFamily: "",

            // Contributions
            employeeContributionEmployeeOnly: 0,
            employerContributionEmployeeOnly: 0,
            employeeContributionEmployeeSpouse: 0,
            employerContributionEmployeeSpouse: 0,
            employeeContributionEmployeeChildren: 0,
            employerContributionEmployeeChildren: 0,
            employeeContributionFamily: 0,
            employerContributionFamily: 0
        }
    ]);

    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchCarriers = async () => {
            try {
                const { data } = await api.get("/insurance-carriers");
                setCarriers(data);
            } catch (err) {
                console.error("Failed to fetch carriers:", err);
            }
        };
        fetchCarriers();
    }, []);

    const calculateContributions = (plan) => {
        const empShare = parseFloat(plan.employeeShare || 0);
        const erShare = 100 - empShare;

        plan.employerShare = erShare;

        const tiers = [
            "EmployeeOnly",
            "EmployeeSpouse",
            "EmployeeChildren",
            "Family"
        ];

        tiers.forEach((tier) => {
            const cost = parseFloat(plan[`cost${tier}`] || 0);
            plan[`employeeContribution${tier}`] = ((cost * empShare) / 100).toFixed(2);
            plan[`employerContribution${tier}`] = ((cost * erShare) / 100).toFixed(2);
        });
    };

    const handleChange = (index, field, value) => {
        const updated = [...plans];
        updated[index][field] = value;

        const plan = updated[index];

        if (
            field === "employeeShare" ||
            field.startsWith("costEmployee") ||
            field === "costFamily"
        ) {
            calculateContributions(plan);
        }

        setPlans(updated);
    };

    const addPlan = () => {
        setPlans([...plans, JSON.parse(JSON.stringify(plans[0]))]);
    };

    const removePlan = (index) => {
        const updated = plans.filter((_, i) => i !== index);
        setPlans(updated);
    };

    const handleSave = async () => {
        try {
            setSaving(true);
            setMessage("");

            for (const plan of plans) {
                const payload = {
                    business_id: id,
                    type: plan.type,
                    plan_name: plan.planName,
                    carrier_id: plan.carrierId,
                    employee_share: parseFloat(plan.employeeShare),
                    employer_share: parseFloat(plan.employerShare),

                    cost_employee_only: parseFloat(plan.costEmployeeOnly || 0),

                    cost_employee_spouse: parseFloat(plan.costEmployeeSpouse || 0),

                    cost_employee_children: parseFloat(plan.costEmployeeChildren || 0),

                    cost_family: parseFloat(plan.costFamily || 0)
                };

                await api.post("/benefit-plans", payload);
            }

            setMessage("Plans saved successfully!");
        } catch (err) {
            console.error("Error saving plans:", err);
            setMessage("Error saving plans.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="benefits-setup">
            <h2>Benefit Plan Setup</h2>

            {plans.map((plan, index) => (
                <div key={index} className="benefit-plan-form">
                    <label>
                        Plan Type:
                        <select value={plan.type} onChange={(e) => handleChange(index, "type", e.target.value)}>
                        <option value="">Select</option>
                        <option value="dental">Dental</option>
                            
                        </select>
                    </label>

                    <label>
                        Plan Name:
                        <input
                            type="text"
                            value={plan.planName}
                            onChange={(e) => handleChange(index, "planName", e.target.value)}
                        />
                    </label>

                    <label>
                        Carrier:
                        <select
                            value={plan.carrierId}
                            onChange={(e) => handleChange(index, "carrierId", e.target.value)}
                        >
                            <option value="">-- Select Carrier --</option>
                            {carriers.map((carrier) => (
                                <option key={carrier.id} value={carrier.id}>
                                    {carrier.name}
                                </option>
                            ))}
                        </select>
                    </label>

                    {plan.carrierId && (
                        <div className="carrier-logo">
                            <img
                                src={carriers.find(c => c.id === parseInt(plan.carrierId))?.logo_url}
                                alt="Carrier Logo"
                                height={40}
                            />
                        </div>
                    )}

                    <div className="share-inputs">
                        <label>
                            Employee Share (%):
                            <input
                                type="number"
                                value={plan.employeeShare}
                                onChange={(e) => handleChange(index, "employeeShare", e.target.value)}
                            />
                        </label>
                        <label>
                            Employer Share (%):
                            <input
                                type="number"
                                value={plan.employerShare}
                                disabled
                            />
                        </label>
                    </div>

                    {["EmployeeOnly", "EmployeeSpouse", "EmployeeChildren", "Family"].map((tier) => (
                        <div key={tier} className="tier-section">
                            <h4>{tier.replace(/([A-Z])/g, " $1").trim()}</h4>

                            <label>
                                Total Cost ($):
                                <input
                                    type="number"
                                    value={plan[`cost${tier}`]}
                                    onChange={(e) => handleChange(index, `cost${tier}`, e.target.value)}
                                />
                            </label>

                            <p>
                                Employee Pays: ${plan[`employeeContribution${tier}`]} <br />
                                Employer Pays: ${plan[`employerContribution${tier}`]}
                            </p>
                        </div>
                    ))}

                    {plans.length > 1 && (
                        <button type="button" className="remove-btn" onClick={() => removePlan(index)}>
                            Remove
                        </button>
                    )}
                </div>
            ))}

            <div className="plan-buttons">
                <button type="button" onClick={addPlan}>Add Another Plan</button>
                <button type="button" onClick={handleSave} disabled={saving}>
                    {saving ? "Saving..." : "Save Plans"}
                </button>
            </div>

            {message && <p className="status-message">{message}</p>}
        </div>
    );
};

export default BenefitsDental;